const exps = {
  test : [
     {
        exp: /^.{8,20}$/, // 길이제
        msg: 'test00',
        use: true,
        proc: true
     }, {
        exp: /\s/, // 공백불가
        msg: 'test01',
        use: true,
        proc: false
     }, {
        exp: /^[a-zA-Z].*/, //영문시작
        msg: 'test02',
        use: true,
        proc: true
     }, {
        exp: /[a-zA-Z]+/, //조합
        msg: 'test03',
        use: true,
        proc: true
     },
     {
        exp: /[\d]+/, //조합
        msg: 'test03',
        use: true,
        proc: true
     },
     {
        exp: /[\W]+/, //조합
        msg: 'test03',
        use: true,
        proc: true
     },
  ],
  exec : [
     {  // 쉬운단어
        exp: /.*(password|qwerty|football|1234|baseball|welcome|abc123|111111|1qaz2wsx|dragon|master|monkey|letmein|login|princess|qwertyuiop|solo|passw0rd|starwars).*/,
        msg: 'exec00',
        use: true
     }, { // 연속입력
        exp: /.*(0123|1234|2345|3456|4567|5678|6789|7890|8901|9012|abcd|bcde|cdef|defg|efgh|fghi|ghij|hijk|ijkl|jklm|klmn|lmno|mnop|nopq|opqr|pqrs|qrst|rstu|stuv|tuvw|uvwx|vwxy|wxyz|qwer|wert|erty|rtyu|tyui|yuio|uiop|asdf|sdfg|dfgh|fghj|ghjk|hjkl|zxcv|xcvb|cvbn|vbnm).*/,
        msg: 'exec01',
        use: true,
     }, { // 반복입력
        exp: /.*(.)\1\1\1.*/,
        msg: 'exec02',
        use: true,
     },
  ],
}

function testValid(pw){
  let resultCode = '';
  let target = '';
  const isValid = exps.test.every((testItem) => {
    if(!testItem.use) return true;
    const testResult = testItem.exp.test(pw);
    const result = testResult === testItem.proc;
    if(!result){
      resultCode = testItem.msg;
    }
    return result;
  });
  return {
    isValid,
    resultCode,
    target
  };
}

function execValid(pw){
  let resultCode = '';
  let target = '';
  const isValid = !exps.exec.some((testItem) => {
    if(!testItem.use) return false;
    const result = testItem.exp.exec(pw);
    if(result){
      resultCode = testItem.msg;
      target = result[1];
    }
    return result;
  });
  return {
    isValid,
    resultCode,
    target
  };
}

export function checkPwValid(pw){
  let result = testValid(pw);
  if(result.isValid){
    result = execValid(pw);
  }
  return result;
}
